<template>
  <div class="outfits-content">

    <section class="top-selection" v-if="!isNavHide">
      <div class="sidebar-title">穿搭</div>
      <div class="container">
        <div class="top-categories">
          <div class="all-categories">

            <div class="top-category">
              <router-link :to="{ name: 'OutfitsIndex'}" class="list-btn">
                <span>我的穿搭</span>
              </router-link>
            </div>
            <div class="top-category">
              <router-link :to="{ name: 'OutfitsPlanner'}" class="list-btn">
                <span>穿搭計畫</span>
              </router-link>
            </div>
            <div class="top-category">
              <router-link :to="{ name: 'FollowedClosets'}" class="list-btn">
                <span>好友的穿搭</span>
              </router-link>
            </div>

          </div>

        </div>
      </div>
    </section>

    <section v-if="init" class="bottom-content">
      <router-view />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
  name: 'OutfitsContent',
  data() {
    return {
      init: false,
      childrenBusy: false,
    };
  },
  components: {
  },
  beforeDestroy() {
    this.$emit('busy', false);
  },
  computed: {
    ...mapGetters(['isNavHide', 'isBottomNavHide', 'isTester']),
    busy() {
      return this.childrenBusy;
    },
	},
  watch: {
    busy(val) {
      this.$emit('busy', val);
    },
  },
  async mounted() {
    try {
      this.init = true;
    } catch(e) {
      console.error(e);
      this.$emit('error', e.toString());
    }
	},
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

  .outfits-content {
    max-height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .top-selection {
    flex: 0 0 auto;
  }

  // 手機版：sidebar 標題隱藏
  .sidebar-title {
    display: none;
  }

  .top-categories {
    padding: .5rem 0 1rem;
    width: 100%;
    overflow-x: auto;
    // white-space: nowrap;
    // text-align: center;

    .all-categories {
      display: flex;
      justify-content: center;
      flex-wrap: nowrap;
      column-gap: .5rem;
      .top-category {
        flex: 0 0 auto;
        >a.list-btn {
          display: flex;
          column-gap: .5rem;
          color: var(--text-color-main);
          padding: .375rem .75rem;
          border-radius: 999px;
          transition: color .4s ease, background-color .4s ease;
          background-color: transparent;
          &:hover {
            text-decoration: none;
          }
          &.router-link-active {
            background-color: var(--icon-color-highlight);
            color: #fff;
            path {
              stroke: #fff;
            }
          }
        }
      }
    }
  }

  .bottom-content {
    flex: 1 1;
    overflow-y: scroll;
  }

  // 桌機 / iPad 橫式：左側 sidebar + 右側內容
  @include bigger-than-large {
    .outfits-content {
      flex-direction: row;
    }

    .top-selection {
      flex: 0 0 240px;
      width: 240px;
      border-right: 1px solid #E9E9E9;
      background-color: $color-gray-light;
      overflow-y: auto;
      padding: 1.25rem 0;
      display: flex;
      flex-direction: column;
    }

    .sidebar-title {
      display: block;
      padding: 0 1.25rem .75rem;
      font-size: 1.125rem;
      font-weight: bold;
      color: var(--text-color-main);
      border-bottom: 1px solid #E9E9E9;
      margin-bottom: .5rem;
    }

    .top-categories {
      padding: 0;
      overflow-x: visible;
      overflow-y: visible;

      .all-categories {
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
        column-gap: 0;
        row-gap: 2px;

        .top-category {
          width: 100%;
          padding: 0 .5rem;

          >a.list-btn {
            width: 100%;
            padding: .75rem 1.25rem;
            border-radius: .5rem;
            font-weight: 500;
            transition: background-color .15s ease, color .15s ease;

            &:hover {
              background-color: rgba(0, 0, 0, .04);
            }

            &.router-link-active {
              background-color: var(--icon-color-highlight);
              color: #fff;
              path {
                stroke: #fff;
                &:not([fill="none"]) {
                  fill: #fff;
                }
              }
            }
          }
        }
      }
    }

    .bottom-content {
      flex: 1 1 auto;
      min-width: 0;
      padding-top: 3rem;
    }
  }

</style>
